var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMelons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.775,
    height: 16.579,
    viewBox: "0 0 20.775 16.579",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3377",
    "data-name": "Group 3377",
    transform: "translate(0.35 0.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3477",
    "data-name": "Path 3477",
    d: "M1337.615,303.567a2.657,2.657,0,0,1-1.791-.558.35.35,0,0,1,.485-.5,2.532,2.532,0,0,0,2.611,0,.35.35,0,1,1,.485.5A2.658,2.658,0,0,1,1337.615,303.567Z",
    transform: "translate(-1330.799 -301.735)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3478",
    "data-name": "Path 3478",
    d: "M1323.028,315.148a6.638,6.638,0,0,1-5.035-2.283,9.771,9.771,0,0,1,0-12.014,6.638,6.638,0,0,1,5.035-2.283,6.712,6.712,0,0,1,5.832,3.371.35.35,0,1,1-.6.361,6.026,6.026,0,0,0-5.233-3.033,5.947,5.947,0,0,0-4.511,2.046,9.078,9.078,0,0,0,0,11.088,6,6,0,0,0,7.689,1.138.35.35,0,1,1,.373.592A6.648,6.648,0,0,1,1323.028,315.148Z",
    transform: "translate(-1316.278 -298.919)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3479",
    "data-name": "Path 3479",
    d: "M1347.353,310.6h0a9.372,9.372,0,0,1,2.956.491,8.623,8.623,0,0,1,4.268,2.98,4.592,4.592,0,0,1,.852,4.188,4.246,4.246,0,0,1-2.028,2.353,6.975,6.975,0,0,1-3.408.818,9.371,9.371,0,0,1-2.956-.491,8.623,8.623,0,0,1-4.268-2.98,4.591,4.591,0,0,1-.852-4.188,4.246,4.246,0,0,1,2.028-2.353A6.974,6.974,0,0,1,1347.353,310.6Zm2.64,10.129c2.356,0,4.229-1.056,4.772-2.691.78-2.349-1.318-5.168-4.677-6.283a8.672,8.672,0,0,0-2.735-.455c-2.356,0-4.229,1.056-4.772,2.691a3.914,3.914,0,0,0,.754,3.556,7.921,7.921,0,0,0,3.923,2.728A8.673,8.673,0,0,0,1349.993,320.728Z",
    transform: "translate(-1335.203 -307.747)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3174",
    "data-name": "Group 3174",
    transform: "translate(9.136 5.473)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3173",
    "data-name": "Group 3173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3480",
    "data-name": "Path 3480",
    d: "M1356.253,325.418a7.1,7.1,0,0,1-2.24-.375,6.439,6.439,0,0,1-3.149-2.162,2.5,2.5,0,0,1-.533-2.135c.326-.982,1.614-1.616,3.281-1.616a7.1,7.1,0,0,1,2.239.375,6.437,6.437,0,0,1,3.149,2.162,2.5,2.5,0,0,1,.533,2.135C1359.208,324.783,1357.92,325.418,1356.253,325.418Zm-2.64-5.588c-1.318,0-2.394.467-2.617,1.136a1.9,1.9,0,0,0,.434,1.5,5.729,5.729,0,0,0,2.8,1.91,6.4,6.4,0,0,0,2.019.339c1.319,0,2.395-.467,2.616-1.136a1.9,1.9,0,0,0-.434-1.5,5.727,5.727,0,0,0-2.8-1.91A6.4,6.4,0,0,0,1353.613,319.83Z",
    transform: "translate(-1350.599 -319.48)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3481",
    "data-name": "Path 3481",
    d: "M1361.433,328.41a5.4,5.4,0,0,1-1.7-.288,4.78,4.78,0,0,1-2.307-1.546l0-.005a.582.582,0,0,1,.3-.9,3.733,3.733,0,0,1,1.072-.145,5.4,5.4,0,0,1,1.7.288,4.783,4.783,0,0,1,2.306,1.544l.006.008a.582.582,0,0,1-.3.9A3.732,3.732,0,0,1,1361.433,328.41ZM1358.1,326.3a4.25,4.25,0,0,0,1.855,1.158,4.7,4.7,0,0,0,1.482.252,3.264,3.264,0,0,0,.7-.07,4.251,4.251,0,0,0-1.854-1.158,4.706,4.706,0,0,0-1.482-.252A3.266,3.266,0,0,0,1358.1,326.3Z",
    transform: "translate(-1346.643 -318.702)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3482",
    "data-name": "Path 3482",
    d: "M1347.345,330.745a7.116,7.116,0,0,1-6.482-4,7.455,7.455,0,0,1,.106-6.4.35.35,0,0,1,.641.281,6.785,6.785,0,0,0-.114,5.824,6.467,6.467,0,0,0,6.682,3.552,6.125,6.125,0,0,0,4.152-2.633,10.1,10.1,0,0,0,1.32-2.341.35.35,0,0,1,.658.238,10.61,10.61,0,0,1-1.407,2.509,6.892,6.892,0,0,1-4.639,2.923A7.633,7.633,0,0,1,1347.345,330.745Z",
    transform: "translate(-1334.085 -314.739)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMelons);
export default __webpack_public_path__ + "static/media/melons.8dc2456cb256f502a212ae8f1de8459a.svg";
export { ForwardRef as ReactComponent };